export default __webpack_public_path__ + "f15410e8d8f997049e38f1dc4126a271.png";